import * as React from 'react';
import {Device} from "@/store/Device";

/**
 * Mobile 과 PC 에서 적절히 하위 항목을 렌더하기 위한 Grid
 * Mobile 에서는 세로로 쌓이고, PC 에서는 가로로 나열됨
 */
export function FtGrid(props: { children: React.ReactNode, gap?: number }) {
    return <div style={{
        display: 'flex',
        width: '100%',
        flexDirection: Device.isMobile ? 'column' : 'row',
        gap: props.gap ?? (Device.isMobile ? 8 : 16),
    }}>{props.children}</div>;
}

export function FtGridCol(props: { children: React.ReactNode }) {
    return <div style={{
        flex: Device.isMobile ? undefined : 1,
    }}>
        {props.children}
    </div>
}